import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const VehicleStatusReport = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); 
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Vehicle Status Report", "view");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/vehicle_status_report`
        );
       const branchColumns = response.data.length > 0 
  ? Object.keys(response.data[0]).filter(
      key => key !== "vehicle_names" && key !== "vehicle_type" && key !== "own_count" && key !== "hire_count"
    ) 
  : [];

      setBranches(branchColumns); 
      setData(response.data || []);
      setFilteredData(response.data || []); 
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);


  // Pagination handling
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);



  // Search functionality
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => 
      item.vehicle_names && item.vehicle_names.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  };

   if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right status-report">
        <section>
          <h2 className="add-txt">Vehicle Status Report</h2>
          <div><Time /></div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input 
            type="text" 
            placeholder="Search by vehicleName" 
            value={searchTerm} 
            onChange={handleSearch} 
            className="search-input" 
          />
        </div>

       <div className="content-table">
  <table>
    <thead>
  <tr>
    <th>S.No</th>
    <th>Vehicle Names</th>
    <th>Vehicle Type</th>
    <th>Own Count</th>
    <th>Hire Count</th>
    {branches.map((branch, index) => (
      <th key={index}>{branch}</th>
    ))}
  </tr>
</thead>
<tbody>
  {currentData.map((item, index) => (
    <tr key={index}>
      <td>{indexOfFirstItem + index + 1}</td>
      <td style={{ minWidth: "300px", whiteSpace: "pre-wrap" }}>
        {item.vehicle_names}
      </td>
      <td>{item.vehicle_type}</td>
      <td>{item.own_count}</td>
      <td>{item.hire_count}</td>
      {branches.map((branch, branchIndex) => (
        <td key={branchIndex}>{item[branch]}</td>
      ))}
    </tr>
  ))}
</tbody>

  </table>
</div>


        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleStatusReport;
